import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/videos';

export default function FeaturedVideos() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                精选推荐
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                编辑精选 · 不容错过的精彩内容
              </p>
            </div>
            <Link
              to="/category/highlights"
              className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {featuredVideos.map((video) => (
              <Link
                key={video.id}
                to={`/article/${video.slug}`}
                className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300"></div>
                  <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded-md font-medium">
                    {video.duration}
                  </span>
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs rounded-full font-medium">
                    {video.category}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {video.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                    {video.excerpt}
                  </p>
                  <div className="flex items-center gap-4 mt-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-eye-line"></i>
                      </span>
                      {video.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-calendar-line"></i>
                      </span>
                      {video.date}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-8 text-center sm:hidden">
            <Link
              to="/category/highlights"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部精选
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}